"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_JUMP_VELOCITY = exports.PLAYER_SPEED = void 0;
exports.PLAYER_SPEED = 50;
exports.PLAYER_JUMP_VELOCITY = 60;
